const ONE_DAY_IN_MILLIS = 1000 * 60 * 60 * 24;

/**
 * Generic function to check if the data is disabled or not based on a condition
 * @param condition
 * @returns date disabling status
 */
export function isDateDisabled(
  handleDateDisabledCondition: (daysDifference: number) => boolean,
  now: Date = new Date(),
) {
  return (date: Date): boolean => {
    const currentDay = Date.UTC(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
    );
    const userProvidedDay = Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
    );
    const days = (userProvidedDay - currentDay) / ONE_DAY_IN_MILLIS;
    return handleDateDisabledCondition(days);
  };
}

/**
 * Dont disable any dates
 * @param date date
 * @returns false
 */
/* export const dontDisableDates = (date: Date): boolean => {
  return false;
}; */

export enum DATE_DISABLED_FUNCTIONS {
  DATE_LESS_THAN_TODAY = 'DATE_LESS_THAN_TODAY',
  DATE_LESS_THAN_TODAY_PLUS_1_DAY = 'DATE_LESS_THAN_TODAY_PLUS_1_DAY',
  DATE_MORE_THAN_TODAY = 'DATE_MORE_THAN_TODAY',
  DONT_DISABLE = 'DONT_DISABLE',
}

export const ConditionFunctionMapping: {
  [key in DATE_DISABLED_FUNCTIONS]: (days: number) => boolean;
} = {
  [DATE_DISABLED_FUNCTIONS.DATE_LESS_THAN_TODAY]: (days: number) => days < 0,
  [DATE_DISABLED_FUNCTIONS.DATE_MORE_THAN_TODAY]: (days) => days > 0,
  [DATE_DISABLED_FUNCTIONS.DATE_LESS_THAN_TODAY_PLUS_1_DAY]: (days) =>
    days <= 1,
  [DATE_DISABLED_FUNCTIONS.DONT_DISABLE]: () => false,
};

// Check which option to be choosen for disabling of dates.
export const dateDisabledOptions = (
  options: DATE_DISABLED_FUNCTIONS,
): ((date: Date) => boolean) => {
  switch (options) {
    case DATE_DISABLED_FUNCTIONS.DATE_LESS_THAN_TODAY:
      return isDateDisabled(ConditionFunctionMapping.DATE_LESS_THAN_TODAY);
    case DATE_DISABLED_FUNCTIONS.DATE_MORE_THAN_TODAY:
      return isDateDisabled(ConditionFunctionMapping.DATE_MORE_THAN_TODAY);
    case DATE_DISABLED_FUNCTIONS.DATE_LESS_THAN_TODAY_PLUS_1_DAY:
      return isDateDisabled(
        ConditionFunctionMapping.DATE_LESS_THAN_TODAY_PLUS_1_DAY,
      );
    case DATE_DISABLED_FUNCTIONS.DONT_DISABLE:
      return () => false;
    default:
      return isDateDisabled(ConditionFunctionMapping.DATE_LESS_THAN_TODAY);
  }
};
